import moment from 'moment'

/**
 * Get this month settlement quote (leads)
 * @param array arrS
 * @returns object
 */
export function fnGetThisMonthData (arrS) {

    if(arrS.length == 0){
        return {}
    }

    let obj = {}
    let lenDays = moment().daysInMonth()
    let arrThisMonthQuote = []
    let arrThisMonthSettlement = []
    let arrLabel = []
    let totQuote = 0
    let totSettlement = 0
    let totInc = 0

    for (var i = 0, len = lenDays; i <= len; i++) {
    arrThisMonthQuote[i] = 0
    arrThisMonthSettlement[i] = 0
    arrLabel[i] = i

    // Settlement Quote for the month
    for (var k = 0, lenk = arrS.length; k < lenk; k++) {
        let s2 = 0
        if (moment(arrS[k].settlementDate).format('DD') == i) {
        s2 = arrThisMonthSettlement[i]
        arrThisMonthSettlement[i] = Number(s2) + 1
        totSettlement = totSettlement + 1

        totInc = Number(totInc) + Number(arrS[k].reportingCommission)
        }
    }
    }

    obj = {
    dataQuotes: arrThisMonthQuote,
    dataSettlements: arrThisMonthSettlement,
    dataLabels: arrLabel,
    dataTotQuotes: totQuote,
    dataTotSettlement: totSettlement,
    dataTotInc: totInc
    }

    return obj
}


  /**
   * Get Last month settlement quote (leads)
   * @param array arrS 
   * @returns object
   */
export function  fnGetLastMonthData(arrS) {

    if(arrS.length == 0){
        return {}
    }

    let obj = {}
    let lenDays = moment().add(-1, 'month').daysInMonth()
    let arrLastMonthQuote = []
    let arrLastMonthSettlement = []
    let arrLabel = []
    let totQuote = 0
    let totSettlement = 0
    let totInc = 0

    for (var i = 0, len = lenDays; i <= len; i++) {
      arrLastMonthQuote[i] = 0
      arrLastMonthSettlement[i] = 0
      arrLabel[i] = i

      // Last month Settlement
      for (var k = 0, lenk = arrS.length; k < lenk; k++) {
        let s = 0

        if (moment(arrS[k].settlementDate).format('DD') == i) {
          s = arrLastMonthSettlement[i]
          arrLastMonthSettlement[i] = Number(s) + 1
          totSettlement = totSettlement + 1

          totInc = Number(totInc) + Number(arrS[k].reportingCommission)
        }
      }
    }

    obj = {
      dataQuotes: arrLastMonthQuote,
      dataSettlements: arrLastMonthSettlement,
      dataLabels: arrLabel,
      dataTotQuotes: totQuote,
      dataTotSettlement: totSettlement,
      dataTotInc: totInc
    }
    return obj
}


/**
 * Get last year settlement data
 * @param array arrS 
 * @returns 
 */
export function fnGetDashboardInformation(arrS) {

    if(arrS.length == 0){
        return {}
    }

    let obj = {}
    const currentDate = moment().format('YYYY-MM-DD')
    let settlementsMonth01 = 0
    let settlementsMonth02 = 0
    let settlementsMonth03 = 0
    let settlementsMonth04 = 0
    let settlementsMonth05 = 0
    let settlementsMonth06 = 0
    let settlementsMonth07 = 0
    let settlementsMonth08 = 0
    let settlementsMonth09 = 0
    let settlementsMonth10 = 0
    let settlementsMonth11 = 0
    let settlementsMonth12 = 0

    let monthText01 = ''
    let monthText02 = ''
    let monthText03 = ''
    let monthText04 = ''
    let monthText05 = ''
    let monthText06 = ''
    let monthText07 = ''
    let monthText08 = ''
    let monthText09 = ''
    let monthText10 = ''
    let monthText11 = ''
    let monthText12 = ''
    let dataGetLastYearDetails = []
    let totalQuotes = 0
    let settCount = 0
    let totalSettlements = 0
    let totInc = 0

    for (var i = 0, len = arrS.length; i < len; i++) {
      //Total whole Settlements quotes
      settCount = Number(settCount) + 1
      totalSettlements = settCount

      if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(0, 'month').format('YYYY-MM')
      ) {
        settlementsMonth01 = Number(settlementsMonth01) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-1, 'month').format('YYYY-MM')
      ) {
        settlementsMonth02 = Number(settlementsMonth02) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-2, 'month').format('YYYY-MM')
      ) {
        settlementsMonth03 = Number(settlementsMonth03) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-3, 'month').format('YYYY-MM')
      ) {
        settlementsMonth04 = Number(settlementsMonth04) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-4, 'month').format('YYYY-MM')
      ) {
        settlementsMonth05 = Number(settlementsMonth05) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-5, 'month').format('YYYY-MM')
      ) {
        settlementsMonth06 = Number(settlementsMonth06) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-6, 'month').format('YYYY-MM')
      ) {
        settlementsMonth07 = Number(settlementsMonth07) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-7, 'month').format('YYYY-MM')
      ) {
        settlementsMonth08 = Number(settlementsMonth08) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-8, 'month').format('YYYY-MM')
      ) {
        settlementsMonth09 = Number(settlementsMonth09) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-9, 'month').format('YYYY-MM')
      ) {
        settlementsMonth10 = Number(settlementsMonth10) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-10, 'month').format('YYYY-MM')
      ) {
        settlementsMonth11 = Number(settlementsMonth11) + 1
      } else if (
        moment(arrS[i].settlementDate).format('YYYY-MM') ==
        moment(currentDate).add(-11, 'month').format('YYYY-MM')
      ) {
        settlementsMonth12 = Number(settlementsMonth12) + 1
      }

      //Total whole Settlements quotes
      totInc = Number(totInc) + Number(arrS[i].reportingCommission)
    }

    monthText01 = moment(currentDate).add(0, 'month').format('MMM')
    monthText02 = moment(currentDate).add(-1, 'month').format('MMM')
    monthText03 = moment(currentDate).add(-2, 'month').format('MMM')
    monthText04 = moment(currentDate).add(-3, 'month').format('MMM')
    monthText05 = moment(currentDate).add(-4, 'month').format('MMM')
    monthText06 = moment(currentDate).add(-5, 'month').format('MMM')
    monthText07 = moment(currentDate).add(-6, 'month').format('MMM')
    monthText08 = moment(currentDate).add(-7, 'month').format('MMM')
    monthText09 = moment(currentDate).add(-8, 'month').format('MMM')
    monthText10 = moment(currentDate).add(-9, 'month').format('MMM')
    monthText11 = moment(currentDate).add(-10, 'month').format('MMM')
    monthText12 = moment(currentDate).add(-11, 'month').format('MMM')

    dataGetLastYearDetails = [
      {
        dataSettlements: settlementsMonth01,
        month: monthText01
      },
      {
        dataSettlements: settlementsMonth02,
        month: monthText02
      },
      {
        dataSettlements: settlementsMonth03,
        month: monthText03
      },
      {
        dataSettlements: settlementsMonth04,
        month: monthText04
      },
      {
        dataSettlements: settlementsMonth05,
        month: monthText05
      },
      {
        dataSettlements: settlementsMonth06,
        month: monthText06
      },
      {
        dataSettlements: settlementsMonth07,
        month: monthText07
      },
      {
        dataSettlements: settlementsMonth08,
        month: monthText08
      },
      {
        dataSettlements: settlementsMonth09,
        month: monthText09
      },
      {
        dataSettlements: settlementsMonth10,
        month: monthText10
      },
      {
        dataSettlements: settlementsMonth11,
        month: monthText11
      },
      {
        dataSettlements: settlementsMonth12,
        month: monthText12
      }
    ]

    let dataSettlements = dataGetLastYearDetails.map(
      (obj) => obj.dataSettlements
    )
    let labelMonths = dataGetLastYearDetails.map((obj) => obj.month)

    obj = {
      dataSettlements: dataSettlements,
      dataLabels: labelMonths,
      dataTotQuotes: totalQuotes,
      dataTotSettlement: totalSettlements,
      dataTotInc: totInc
    }
    return obj
}


/**
 * Get this month all Leads
 * @param array arrS
 * @returns object
 */
export function fnGetThisMonthLeadsData (arrS) {

    if(arrS.length == 0){
        return {}
    }

    let obj = {}
    let lenDays = moment().daysInMonth()
    let arrThisMonthQuote = []
    let arrLabel = []
    let totQuote = 0

    for (var i = 0, len = lenDays; i <= len; i++) {
    arrThisMonthQuote[i] = 0
    arrLabel[i] = i

    // Quote for the month
    for (var k = 0, lenk = arrS.length; k < lenk; k++) {
            let s2 = 0
            if (moment(arrS[k].createdAt).format('DD') == i) {
                s2 = arrThisMonthQuote[i]
                arrThisMonthQuote[i] = Number(s2) + 1

                //Total whole quotes
                totQuote = Number(totQuote) + 1
            }
        }
    }

    obj = {
    dataQuotes: arrThisMonthQuote,
    dataLabels: arrLabel,
    dataTotQuotes: totQuote,
    }

    return obj
}


  /**
   * Get Last month All Leads
   * @param array arrS 
   * @returns object
   */
export function  fnGetLastMonthLeadsData(arrS) {

    if(arrS.length == 0){
        return {}
    }

    let obj = {}
    let lenDays = moment().add(-1, 'month').daysInMonth()
    let arrLastMonthQuote = []
    let arrLabel = []
    let totQuote = 0

    for (var i = 0, len = lenDays; i <= len; i++) {
      arrLastMonthQuote[i] = 0
      arrLabel[i] = i

      // Last month Settlement
      for (var k = 0, lenk = arrS.length; k < lenk; k++) {
        let s = 0

        if (moment(arrS[k].createdAt).format('DD') == i) {
            s = arrLastMonthQuote[i]
            arrLastMonthQuote[i] = Number(s) + 1

            //Total whole quotes
            totQuote = Number(totQuote) + 1
        }
      }
    }

    obj = {
      dataQuotes: arrLastMonthQuote,
      dataLabels: arrLabel,
      dataTotQuotes: totQuote,
    }
    return obj
}


/**
 * Get last year All leads data
 * @param array arrS 
 * @returns 
 */
export function fnGetDashboardLeadsInformation(arrS) {

    if(arrS.length == 0){
        return {}
    }

    let obj = {}
    const currentDate = moment().format('YYYY-MM-DD')
    let month01 = 0
    let month02 = 0
    let month03 = 0
    let month04 = 0
    let month05 = 0
    let month06 = 0
    let month07 = 0
    let month08 = 0
    let month09 = 0
    let month10 = 0
    let month11 = 0
    let month12 = 0

    let monthText01 = ''
    let monthText02 = ''
    let monthText03 = ''
    let monthText04 = ''
    let monthText05 = ''
    let monthText06 = ''
    let monthText07 = ''
    let monthText08 = ''
    let monthText09 = ''
    let monthText10 = ''
    let monthText11 = ''
    let monthText12 = ''
    let dataGetLastYearDetails = []
    let totalQuotes = 0

    for (var i = 0, len = arrS.length; i < len; i++) {
      //Total whole quotes
      totalQuotes = Number(totalQuotes) + 1


      if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(0, 'month').format('YYYY-MM')
      ) {
        month01 = Number(month01) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-1, 'month').format('YYYY-MM')
      ) {
        month02 = Number(month02) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-2, 'month').format('YYYY-MM')
      ) {
        month03 = Number(month03) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-3, 'month').format('YYYY-MM')
      ) {
        month04 = Number(month04) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-4, 'month').format('YYYY-MM')
      ) {
        month05 = Number(month05) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-5, 'month').format('YYYY-MM')
      ) {
        month06 = Number(month06) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-6, 'month').format('YYYY-MM')
      ) {
        month07 = Number(month07) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-7, 'month').format('YYYY-MM')
      ) {
        month08 = Number(month08) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-8, 'month').format('YYYY-MM')
      ) {
        month09 = Number(month09) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-9, 'month').format('YYYY-MM')
      ) {
        month10 = Number(month10) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-10, 'month').format('YYYY-MM')
      ) {
        month11 = Number(month11) + 1
      } else if (
        moment(arrS[i].createdAt).format('YYYY-MM') ==
        moment(currentDate).add(-11, 'month').format('YYYY-MM')
      ) {
        month12 = Number(month12) + 1
      }
    }

    monthText01 = moment(currentDate).add(0, 'month').format('MMM')
    monthText02 = moment(currentDate).add(-1, 'month').format('MMM')
    monthText03 = moment(currentDate).add(-2, 'month').format('MMM')
    monthText04 = moment(currentDate).add(-3, 'month').format('MMM')
    monthText05 = moment(currentDate).add(-4, 'month').format('MMM')
    monthText06 = moment(currentDate).add(-5, 'month').format('MMM')
    monthText07 = moment(currentDate).add(-6, 'month').format('MMM')
    monthText08 = moment(currentDate).add(-7, 'month').format('MMM')
    monthText09 = moment(currentDate).add(-8, 'month').format('MMM')
    monthText10 = moment(currentDate).add(-9, 'month').format('MMM')
    monthText11 = moment(currentDate).add(-10, 'month').format('MMM')
    monthText12 = moment(currentDate).add(-11, 'month').format('MMM')

    dataGetLastYearDetails = [
      {
        dataQuotes: month01,
        month: monthText01
      },
      {
        dataQuotes: month02,
        month: monthText02
      },
      {
        dataQuotes: month03,
        month: monthText03
      },
      {
        dataQuotes: month04,
        month: monthText04
      },
      {
        dataQuotes: month05,
        month: monthText05
      },
      {
        dataQuotes: month06,
        month: monthText06
      },
      {
        dataQuotes: month07,
        month: monthText07
      },
      {
        dataQuotes: month08,
        month: monthText08
      },
      {
        dataQuotes: month09,
        month: monthText09
      },
      {
        dataQuotes: month10,
        month: monthText10
      },
      {
        dataQuotes: month11,
        month: monthText11
      },
      {
        dataQuotes: month12,
        month: monthText12
      }
    ]

    let dataQuotes = dataGetLastYearDetails.map(
      (obj) => obj.dataQuotes
    )
    let labelMonths = dataGetLastYearDetails.map((obj) => obj.month)

    obj = {
      dataQuotes: dataQuotes,
      dataLabels: labelMonths,
      dataTotQuotes: totalQuotes,
    }
    return obj
}
  